import axios from 'axios'

const getTrackList = () => {
  return axios.get('/core/api/v1/brief/tracks')
}
export const trackService = {
  getTrackList

}
